export default "__VITE_ASSET__DZH4YO7U__"